import _asyncToGenerator from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/regenerator/index.js";

function initDelta(value) {
  var fpsLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
  var smooth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    value: value,
    factor: smooth ? 60 / fpsLimit : 60 * value / 1000
  };
}

export var FrameManager = /*#__PURE__*/function () {
  function FrameManager(container) {
    _classCallCheck(this, FrameManager);

    this.container = container;
  }

  _createClass(FrameManager, [{
    key: "nextFrame",
    value: function () {
      var _nextFrame = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timestamp) {
        var _a, container, delta;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                container = this.container;

                if (!(!container.smooth && container.lastFrameTime !== undefined && timestamp < container.lastFrameTime + 1000 / container.fpsLimit)) {
                  _context.next = 5;
                  break;
                }

                container.draw(false);
                return _context.abrupt("return");

              case 5:
                (_a = container.lastFrameTime) !== null && _a !== void 0 ? _a : container.lastFrameTime = timestamp;
                delta = initDelta(timestamp - container.lastFrameTime, container.fpsLimit, container.smooth);
                container.lifeTime += delta.value;
                container.lastFrameTime = timestamp;

                if (!(delta.value > 1000)) {
                  _context.next = 12;
                  break;
                }

                container.draw(false);
                return _context.abrupt("return");

              case 12:
                _context.next = 14;
                return container.particles.draw(delta);

              case 14:
                if (!(container.duration > 0 && container.lifeTime > container.duration)) {
                  _context.next = 17;
                  break;
                }

                container.destroy();
                return _context.abrupt("return");

              case 17:
                if (container.getAnimationStatus()) {
                  container.draw(false);
                }

                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                console.error("tsParticles error in animation loop", _context.t0);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 20]]);
      }));

      function nextFrame(_x) {
        return _nextFrame.apply(this, arguments);
      }

      return nextFrame;
    }()
  }]);

  return FrameManager;
}();